import {popupStore,popupEnvironment} from './popup-visibility'
const TTL=30*60*1000
export function recordPopupPage(path:string,now=Date.now()) {
 const key=`journey-popup:${popupEnvironment}:engaged-visit`
 let history:any={}
 try {history=JSON.parse(popupStore.read(key)||'{}')}catch{}
 const fresh=!Number.isFinite(history.lastSeen)||now-history.lastSeen>=TTL
 const prior=Boolean(history.firstSeen)
 const visitorStatus: 'new'|'returning'|'unknown'=fresh?(prior?'returning':'new'):history.visitorStatus||'unknown'
 const canonical=path.split(/[?#]/)[0].replace(/\/$/,'')||'/'
 const paths:string[]=fresh?[]:Array.isArray(history.paths)?history.paths:[]
 const next={firstSeen:history.firstSeen||now,lastSeen:now,startedAt:fresh?now:history.startedAt||now,visitorStatus,paths:Array.from(new Set([...paths,canonical])).slice(-100)}
 popupStore.write(key,JSON.stringify(next))
 // If storage is unavailable we cannot establish browser history reliably.
 let stored:string|null=null
 try{stored=window.localStorage.getItem(key)}catch{}
 return {...next,visitorStatus:stored?visitorStatus:'unknown' as const,pages:next.paths.length}
}
